import { QA, PL, EG } from "country-flag-icons/react/3x2";
import { useTranslation } from "next-i18next";
import { m } from "framer-motion";
import { useMediaQuery } from "usehooks-ts";
import React from "react";

const OfficesSection = () => {
  const { i18n } = useTranslation();
  const [key, setKey] = React.useState(0);
  const rtl = i18n.dir() === "rtl";
  const containerAnimation = {
    hidden: { opcaity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.3,
        ease: "easeOut",
      },
    },
  };

  const isXs = useMediaQuery("(max-width: 600px)", {
    initializeWithValue: false,
  });
  const isSm = useMediaQuery("(min-width: 600px) and (max-width: 900px)", {
    initializeWithValue: false,
  });

  React.useEffect(() => {
    setKey(isXs ? 1 : isSm ? 2 : 3);
  }, [isXs, isSm]);

  return (
    <section className="flex bg-auto-black/5">
      <m.div
        className="container flex flex-col items-center justify-start gap-10 px-4 py-16"
        variants={containerAnimation}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
      >
        <div className="flex flex-col items-center justify-center gap-6 self-stretch">
          <h2
            id="offices"
            className="self-stretch p-0 text-center text-3xl font-bold leading-9 text-primary-700"
          >
            Our Offices
          </h2>
          <div className="flex items-center justify-center gap-2 self-stretch">
            <div className="shrink grow basis-0 text-center text-base font-medium leading-normal text-auto-black/65">
              AlHayat Foodstuff spans the globe, strategically anchored in
              Poland—a gateway to the EU and beyond. From Qatar to Egypt and
              Poland, our network ensures reliable distribution and quality
              excellence.
            </div>
          </div>
        </div>
        <div
          key={key}
          className="grid grid-cols-1 items-center justify-center gap-8 self-stretch sm:grid-cols-2 md:grid-cols-3"
        >
          <m.div
            className="card flex flex-col items-center justify-center gap-6 self-stretch p-6 sm:col-span-2 md:col-span-1"
            initial={
              isXs
                ? { y: 100, opacity: 0 }
                : isSm
                  ? { y: -100, opacity: 0 }
                  : { x: rtl ? 100 : -100, opacity: 0 }
            }
            whileInView={{
              x: 0,
              y: 0,
              opacity: 100,
              transition: { duration: 0.5 },
            }}
            viewport={{ once: true }}
          >
            <div className="flex flex-col items-start justify-start gap-4 self-stretch">
              <PL className="relative h-9 w-9" />
              <div className="self-stretch text-xl font-semibold leading-[30px] text-auto-black/80">
                AlHayat Food Stuff sp. z o.o.
              </div>
            </div>
            <div className="flex flex-col items-start justify-start gap-2 self-stretch">
              <div className="flex items-start justify-start gap-2 self-stretch">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="grommet-icons:location">
                    <path
                      id="Vector"
                      d="M12 22C12 22 4 16 4 10C4 5 8 2 12 2C16 2 20 5 20 10C20 16 12 22 12 22ZM12 13C12.7956 13 13.5587 12.6839 14.1213 12.1213C14.6839 11.5587 15 10.7956 15 10C15 9.20435 14.6839 8.44129 14.1213 7.87868C13.5587 7.31607 12.7956 7 12 7C11.2044 7 10.4413 7.31607 9.87868 7.87868C9.31607 8.44129 9 9.20435 9 10C9 10.7956 9.31607 11.5587 9.87868 12.1213C10.4413 12.6839 11.2044 13 12 13Z"
                      stroke="#a3a3a3"
                      strokeWidth="2"
                    />
                  </g>
                </svg>

                <div className="shrink grow basis-0 text-sm font-medium leading-tight text-auto-black/70">
                  Kamionna 22A
                  <br />
                  06-120 Winnica
                  <br />
                  Poland
                </div>
              </div>
              <div className="flex items-center justify-start gap-2 self-stretch">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="phone">
                    <path
                      id="Path"
                      d="M18.1182 14.702L14 15.5C11.2183 14.1038 9.49997 12.5 8.49997 10L9.26992 5.8699L7.81449 2L4.06357 2C2.93602 2 2.04811 2.93178 2.21651 4.04668C2.63691 6.83 3.8765 11.8765 7.49997 15.5C11.3052 19.3052 16.7857 20.9564 19.802 21.6127C20.9667 21.8662 22 20.9575 22 19.7655L22 16.1812L18.1182 14.702Z"
                      stroke="#a3a3a3"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                </svg>
                <div className="shrink grow basis-0 text-sm font-medium leading-tight text-auto-black/70">
                  +48 514 499 212
                </div>
              </div>
              <div className="flex items-center justify-start gap-2 self-stretch">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="mail">
                    <path
                      id="Vector"
                      d="M7 9L12 12.5L17 9"
                      stroke="#a3a3a3"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      id="Vector_2"
                      d="M2 17V7C2 5.89543 2.89543 5 4 5H20C21.1046 5 22 5.89543 22 7V17C22 18.1046 21.1046 19 20 19H4C2.89543 19 2 18.1046 2 17Z"
                      stroke="#a3a3a3"
                      strokeWidth="1.5"
                    />
                  </g>
                </svg>
                <div className="shrink grow basis-0 text-sm font-medium leading-tight text-auto-black/70">
                  info.pl@alhayatfoodstuff.com
                </div>
              </div>
            </div>
          </m.div>
          <m.div
            className="card flex flex-col items-center justify-center gap-6 self-stretch  p-6"
            initial={
              isXs
                ? { y: 100, opacity: 0 }
                : isSm
                  ? { x: rtl ? 100 : -100, opacity: 0 }
                  : { y: 100, opacity: 0 }
            }
            whileInView={{
              x: 0,
              y: 0,
              opacity: 100,
              transition: { duration: 0.5 },
            }}
            viewport={{ once: true }}
          >
            <div className="flex flex-col items-start justify-start gap-4 self-stretch">
              <EG className="relative h-9 w-9" />
              <div className="self-stretch text-xl font-semibold leading-[30px] text-auto-black/80">
                AlHayat Foodstuff W.L.L.
              </div>
            </div>
            <div className="flex flex-col items-start justify-start gap-2 self-stretch">
              <div className="flex items-start justify-start gap-2 self-stretch">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="grommet-icons:location">
                    <path
                      id="Vector"
                      d="M12 22C12 22 4 16 4 10C4 5 8 2 12 2C16 2 20 5 20 10C20 16 12 22 12 22ZM12 13C12.7956 13 13.5587 12.6839 14.1213 12.1213C14.6839 11.5587 15 10.7956 15 10C15 9.20435 14.6839 8.44129 14.1213 7.87868C13.5587 7.31607 12.7956 7 12 7C11.2044 7 10.4413 7.31607 9.87868 7.87868C9.31607 8.44129 9 9.20435 9 10C9 10.7956 9.31607 11.5587 9.87868 12.1213C10.4413 12.6839 11.2044 13 12 13Z"
                      stroke="#a3a3a3"
                      strokeWidth="2"
                    />
                  </g>
                </svg>
                <div className="shrink grow basis-0 text-sm font-medium leading-tight text-auto-black/70">
                  Building 63, Zone 8, Lotus District
                  <br />
                  5th Settlement, New Cairo
                  <br />
                  Egypt
                </div>
              </div>
              <div className="flex items-center justify-start gap-2 self-stretch">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="phone">
                    <path
                      id="Path"
                      d="M18.1182 14.702L14 15.5C11.2183 14.1038 9.49997 12.5 8.49997 10L9.26992 5.8699L7.81449 2L4.06357 2C2.93602 2 2.04811 2.93178 2.21651 4.04668C2.63691 6.83 3.8765 11.8765 7.49997 15.5C11.3052 19.3052 16.7857 20.9564 19.802 21.6127C20.9667 21.8662 22 20.9575 22 19.7655L22 16.1812L18.1182 14.702Z"
                      stroke="#a3a3a3"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                </svg>
                <div className="shrink grow basis-0 text-sm font-medium leading-tight text-auto-black/70">
                  +20 100 865 1066
                </div>
              </div>
              <div className="flex items-center justify-start gap-2 self-stretch">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="mail">
                    <path
                      id="Vector"
                      d="M7 9L12 12.5L17 9"
                      stroke="#a3a3a3"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      id="Vector_2"
                      d="M2 17V7C2 5.89543 2.89543 5 4 5H20C21.1046 5 22 5.89543 22 7V17C22 18.1046 21.1046 19 20 19H4C2.89543 19 2 18.1046 2 17Z"
                      stroke="#a3a3a3"
                      strokeWidth="1.5"
                    />
                  </g>
                </svg>
                <div className="shrink grow basis-0 text-sm font-medium leading-tight text-auto-black/70">
                  info.eg@alhayatfoodstuff.com
                </div>
              </div>
            </div>
          </m.div>
          <m.div
            className="card flex flex-col items-center justify-center gap-6 self-stretch p-6"
            initial={
              isXs
                ? { y: 100, opacity: 0 }
                : isSm
                  ? { x: rtl ? -100 : 100, opacity: 0 }
                  : { x: rtl ? -100 : 100, opacity: 0 }
            }
            whileInView={{
              x: 0,
              y: 0,
              opacity: 100,
              transition: { duration: 0.5 },
            }}
            viewport={{ once: true }}
          >
            <div className="flex flex-col items-start justify-start gap-4 self-stretch">
              <QA className="relative h-9 w-9" />
              <div className="self-stretch text-xl font-semibold leading-[30px] text-auto-black/80">
                AlHayat Foodstuff Co. W.L.L.
              </div>
            </div>
            <div className="flex flex-col items-start justify-start gap-2 self-stretch">
              <div className="flex items-start justify-start gap-2 self-stretch">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="grommet-icons:location">
                    <path
                      id="Vector"
                      d="M12 22C12 22 4 16 4 10C4 5 8 2 12 2C16 2 20 5 20 10C20 16 12 22 12 22ZM12 13C12.7956 13 13.5587 12.6839 14.1213 12.1213C14.6839 11.5587 15 10.7956 15 10C15 9.20435 14.6839 8.44129 14.1213 7.87868C13.5587 7.31607 12.7956 7 12 7C11.2044 7 10.4413 7.31607 9.87868 7.87868C9.31607 8.44129 9 9.20435 9 10C9 10.7956 9.31607 11.5587 9.87868 12.1213C10.4413 12.6839 11.2044 13 12 13Z"
                      stroke="#a3a3a3"
                      strokeWidth="2"
                    />
                  </g>
                </svg>
                <div className="shrink grow basis-0 text-sm font-medium leading-tight text-auto-black/70">
                  455 Salwa Road
                  <br />
                  Doha
                  <br />
                  Qatar
                </div>
              </div>
              <div className="flex items-center justify-start gap-2 self-stretch">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="phone">
                    <path
                      id="Path"
                      d="M18.1182 14.702L14 15.5C11.2183 14.1038 9.49997 12.5 8.49997 10L9.26992 5.8699L7.81449 2L4.06357 2C2.93602 2 2.04811 2.93178 2.21651 4.04668C2.63691 6.83 3.8765 11.8765 7.49997 15.5C11.3052 19.3052 16.7857 20.9564 19.802 21.6127C20.9667 21.8662 22 20.9575 22 19.7655L22 16.1812L18.1182 14.702Z"
                      stroke="#a3a3a3"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                </svg>
                <div className="shrink grow basis-0 text-sm font-medium leading-tight text-auto-black/70">
                  +974 4421 7308
                </div>
              </div>
              <div className="flex items-center justify-start gap-2 self-stretch">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="mail">
                    <path
                      id="Vector"
                      d="M7 9L12 12.5L17 9"
                      stroke="#a3a3a3"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      id="Vector_2"
                      d="M2 17V7C2 5.89543 2.89543 5 4 5H20C21.1046 5 22 5.89543 22 7V17C22 18.1046 21.1046 19 20 19H4C2.89543 19 2 18.1046 2 17Z"
                      stroke="#a3a3a3"
                      strokeWidth="1.5"
                    />
                  </g>
                </svg>
                <div className="shrink grow basis-0 text-sm font-medium leading-tight text-auto-black/70">
                  info.qa@alhayatfoodstuff.com
                </div>
              </div>
            </div>
          </m.div>
        </div>
      </m.div>
    </section>
  );
};

export default OfficesSection;
